import React, { useCallback, useContext, useMemo } from 'react';
import { EnvContext } from 'States/env/envState';
import { LangContext } from 'States/lang/langState';
import { getTranslation } from 'Helpers/translations';
import useConfigSettings from 'Hooks/useConfigSettings';
import CustomCard from 'Features/Purchase/AssetCard/CustomCard';
import InvestmentCardButtons from '../Investments/InvestmentCardButtons';

const ListingCard = ({ assetConfig, dataQa }) => {
  const { env } = useContext(EnvContext);
  const { lang } = useContext(LangContext);

  const {
    data: defaultLanguage
  } = useConfigSettings.query({
    select: useCallback(
      ({ Languages }) => {
        const defaultLanguage = Languages.find(({ IsDefault }) => IsDefault);
        return defaultLanguage;
      }, []
    )
  });

  const translatedName = useMemo(() => {
    const name = getTranslation("Name", lang, defaultLanguage.Code, assetConfig.Asset.Translations);
    const ticker = getTranslation("Ticker", lang, defaultLanguage.Code, assetConfig.Asset.Translations);
    return ticker ? `${name} (${ticker})` : name;
  }, [lang]);

  const translatedDescription = useMemo(() => getTranslation(
    "Description", lang, defaultLanguage.Code, assetConfig.Asset.Translations
  ), [lang]);

  const {
    translatedAddress,
    translatedLink
  } = useMemo(() => {
    const translatedDefinitionItems = getTranslation(
      "CustomDefinitionItems", lang, defaultLanguage.Code, assetConfig.Asset.Translations
    );
    const addressDefinitionItem = translatedDefinitionItems.find(({ Name }) => Name === "Address");
    const linkDefinitionItem = translatedDefinitionItems.find(({ Name }) => Name === "Link");
    return {
      translatedAddress: addressDefinitionItem?.Value || "",
      translatedLink: linkDefinitionItem?.Value || ""
    };
  }, [lang]);

  const openAssetInfo = () => {
    if (!translatedLink) {
      return;
    }
    window.open(translatedLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <CustomCard
        dataQa={dataQa}
        name={translatedName}
        iconUrl={`${env.BlobUrl}/${assetConfig.Icon}`}
        description={translatedDescription}
        subtitle={translatedAddress}
        buttonGroup={() =>
          InvestmentCardButtons({
            topButtonAction: openAssetInfo,
            kycTier: 0,
            bottomButtonHidden: true
          })
        }
      />
    </>
  );
};

export default ListingCard;
